export const selectConfig = (state) => state.config.data;
export const selectConfigStatus = (state) => state.config.status;
